module.exports = __webpack_public_path__ + "img/ad-2.b2c88fd1.jpg";